var moduleMap = {
	"./ModelEditor": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_react_jsx-runtime_js"), __webpack_require__.e("vendors-node_modules_prop-types_index_js"), __webpack_require__.e("vendors-node_modules_progress_kendo-react-common_classNames_mjs-node_modules_progress_kendo-r-4019d6"), __webpack_require__.e("vendors-node_modules_emotion_react_dist_emotion-element-489459f2_browser_development_esm_js"), __webpack_require__.e("vendors-node_modules_immer_dist_immer_mjs-node_modules_reselect_dist_reselect_mjs"), __webpack_require__.e("vendors-node_modules_emotion_react_dist_emotion-react_browser_development_esm_js-node_modules-6fd12e"), __webpack_require__.e("src_App_tsx")]).then(() => (() => ((__webpack_require__(/*! ./src/App.tsx */ "./src/App.tsx")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});